import React, { useEffect } from 'react';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { CssBaseline, ThemeProvider } from '@mui/material';
import getTheme from './theme/theme';
import { PinnacleThemes } from './theme/types';
import { PinnacleSnackbarProvider } from './components/PinnacleSnackbarProvider';
import { NotificationTypes } from './components/PinnacleSnackbarProvider/PinnacleSnackbarProvider.types';
import { pushNotification } from './components/PinnacleSnackbarProvider/PinnacleSnackbarProvider';
 
const AppContent: React.FC = () => {
  const navigate = useNavigate();
  // const [showTokenExpiredModal, setShowTokenExpiredModal] = useState(false);
  // const [showDeactivatedModal, setShowDeactivatedModal] = useState(false);

  useEffect(() => {
    const onTokenExpired = () => {
      // setShowTokenExpiredModal(true);
      const timer = setTimeout(() => {
        // setShowTokenExpiredModal(false);
        navigate("/login");
      }, 3000);
      return () => clearTimeout(timer);
    };

    const onDeactivated = () => {
      // setShowDeactivatedModal(true);
      const timer = setTimeout(() => {
        // setShowDeactivatedModal(false);
        navigate("/login");
      }, 3000);
      return () => clearTimeout(timer);
    };

    const onUnauthorized = () => {
      // setShowTokenExpiredModal(true);
      const timer = setTimeout(() => {
        // setShowTokenExpiredModal(false);
        navigate("/login");
      }, 3000);
      return () => clearTimeout(timer);
    };

    const onServerError = () => {
      pushNotification({
        details: 'Server error. Please try again later.',
        type: NotificationTypes.Error,
      });
    };

    window.addEventListener('api:tokenExpired', onTokenExpired);
    window.addEventListener('api:deactivatedAccount', onDeactivated);
    window.addEventListener('api:unauthorized', onUnauthorized);
    window.addEventListener('api:serverError', onServerError);

    return () => {
      window.removeEventListener('api:tokenExpired', onTokenExpired);
      window.removeEventListener('api:deactivatedAccount', onDeactivated);
      window.removeEventListener('api:unauthorized', onUnauthorized);
      window.removeEventListener('api:serverError', onServerError);
    };
  }, [navigate]);

  return (
    <>
      <AppRoutes />
    </>
  );
};

const App: React.FC = () => {
  const theme = getTheme(PinnacleThemes.BASE_THEME);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <PinnacleSnackbarProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </PinnacleSnackbarProvider>
    </ThemeProvider>
  );
};

export default App;
